import { useState } from "react";
import { useLocation } from "react-router-dom";

import { useLazyQuery } from "@apollo/client";
import gql from "graphql-tag";
import Permissions from "../configs/permissions";
import usePermissions from "../hooks/permissions";
import PageContainer from "../vaboo-ui/PageContainer";

import {
  allQuestions,
  allSurveys,
} from "./../graphql/queries/vabooSurveyQueries";

const ALL_SURVEYS = gql(allSurveys);
const ALL_QUESTIONS = gql(allQuestions);

const Surveys = (props) => {
  const { hasAccess } = usePermissions();

  const location = useLocation();

  const rootUrl = ``;

  document.title = "Surveys";

  const page = {
    title: "Surveys",
    icon: "content",
    nav: [],
  };

  const [surveys, setSurveys] = useState(null);

  const [questions, setQuestions] = useState(null);

  const [cards, setCards] = useState(null);

  const [getSurveys, { loading: loadingSurveys }] = useLazyQuery(ALL_SURVEYS, {
    skip: surveys !== null,
    variables: {
      page: 1,
      limit: 1000,
      search: "0",
      orderBy: "0",
      orderHow: "0",
    },
    fetchPolicy: "cache-and-network",
    onCompleted: (d) => setSurveys(d.surveys),
  });

  const [getQuestions, { loading: loadingQuestions }] = useLazyQuery(
    ALL_QUESTIONS,
    {
      skip: questions !== null,
      variables: {
        page: 1,
        limit: 1000,
        search: "0",
        orderBy: "0",
        orderHow: "0",
      },
      fetchPolicy: "cache-and-network",
      onCompleted: (d) => setQuestions(d.questions),
    }
  );

  if (!surveys && !loadingSurveys) getSurveys();

  if (!questions && !loadingQuestions) getQuestions();

  if (hasAccess(Permissions.Query.Surveys))
    page.nav.push({
      name: "Surveys",
      url: `${rootUrl}/surveys/1/50/0/0/0`,
      isActive: location.pathname.split("/")[1] === "surveys" ? true : false,
      icon: "database",
    });

  if (hasAccess(Permissions.Query.Questions))
    page.nav.push({
      name: "Questions",
      url: `${rootUrl}/questions/1/50/0/0/0`,
      isActive: location.pathname.split("/")[1] === "questions" ? true : false,
      icon: "chatAlt",
    });

  const navHeader = null;

  const navAction = null;

  return (
    <PageContainer
      page={page}
      entityDetails={{ surveys, questions }}
      {...props}
      navHeader={navHeader}
      navAction={navAction}
    />
  );
};

export default Surveys;
